import { render, staticRenderFns } from "./ShowProductDetails.vue?vue&type=template&id=f40c3964&"
import script from "./ShowProductDetails.vue?vue&type=script&lang=js&"
export * from "./ShowProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports